import { defineStore } from 'pinia';

import usersRepository from '@/api/usersRepository';
import type { CurrentUser } from '@/types/user';

interface State {
  currentUser: CurrentUser | null;
  isAppInitialized: boolean;
}

export const useUserStore = defineStore('userStore', {
  state: (): State => {
    return {
      currentUser: null,
      isAppInitialized: false,
    };
  },

  actions: {
    async getCurrentUser() {
      const { data } = await usersRepository.getCurrentUser();
      this.$state.currentUser = data;

      return data;
    }
  }
});
